import { ApiResponse } from "../types";
import { apiClient } from "./apiClient";
import { Professional } from "./professionalsApi";

export interface Company {
  id: number;
  name: string;
  phoneNumber: string;
  email: string;
  address?: string;
  cnpj?: string | null;
  instagramUrl?: string | null;
  logo?: string;
  signature?: string | null;
  category: "car" | "barbershop";
  createdAt?: Date;
  updatedAt?: Date;
  professionals: Professional[];
}

export interface UpdateCompanyPasswordData {
  oldPassword: string;
  newPassword: string;
}

export const companyApi = {
  // Get company by ID
  async getCompany(): Promise<ApiResponse<Company>> {
    try {
      const data = await apiClient.get<any>(`/companies`);

      return {
        success: true,
        data: data.data || data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Update an existing company
  async updateCompany(
    companyData: Partial<Omit<Company, "id" | "createdAt" | "updatedAt">>
  ): Promise<ApiResponse<Company>> {
    try {
      const data = await apiClient.put<any>(`/companies`, companyData);

      return {
        success: true,
        data: data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Update company password
  async updatePassword(
    passwordData: UpdateCompanyPasswordData
  ): Promise<ApiResponse<{ message: string }>> {
    try {
      const data = await apiClient.put<any>(`/companies/password`, passwordData);

      return {
        success: true,
        data: data.data || { message: data.message || "Senha atualizada com sucesso" },
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Erro ao atualizar senha",
      };
    }
  },
};
